export default "__VITE_ASSET__Bf2hXqZ5__"